class @ContentImporter

  @setup: ->
    $(".import-content-button").off("click.content-importer")
    $(".import-content-button").on("click.content-importer", ContentImporter.openImportDialog)

  @openImportDialog: ->
    # Determine what we're editing.

    $anchor = $(@)
    $contentEditorSection = $anchor.closest(".content-editor-section")
    thisObjectId = $contentEditorSection.data("import-object-id")

    # Generate the form.

    $form = $("<ul></ul>").addClass("form-fields")

    $mailingListLine = $("<li></li>").addClass("form-field clear string field_with_hint").css({ width: "500px" })
    $mailingListLine.append($("<label></label>").addClass("string control-label").text("Mailing List"))
    $mailingListSelect = $("<select></select>").addClass("select").append($("<option></option>").attr("value", "").text("Select a mailing list ..."))
    $mailingListLine.append($mailingListSelect)
    $.getJSON(Routes.api_mailing_lists_path(), (r) => _.each(r.data, (list) => $mailingListSelect.append($("<option></option>").attr("value", list.id).text(list.name))))
    $form.append($mailingListLine)

    $sourceLine = $("<li></li>").addClass("form-field clear string field_with_hint").css({ width: "500px" })
    $sourceLine.append($("<label></label>").addClass("string control-label").text("Source"))
    $sourceSelect = $("<select></select>").addClass("select").append($("<option></option>").attr("value", "").text("Select a source ..."))
    $sourceLine.append($sourceSelect)
    $form.append($sourceLine)
    $sourceLine.hide()

    $contentLine = $("<li></li>").addClass("form-field clear string field_with_hint").css({ width: "500px" })
    $contentLine.append($("<label></label>").addClass("string control-label").text("Content"))
    $contentSelect = $("<select></select>").addClass("select").append($("<option></option>").attr("value", "").text("Select a source ..."))
    $contentLine.append($contentSelect)
    $form.append($contentLine)
    $contentLine.hide()

    $form.find("select").width("300px").select2()

    # Show the modal.

    modal =
      Dialogs.presentModal
        header: "Import Content"
        body: $form
        footer: "hello world"
        dontHideModal: true

    # Functions for enabling/disabling the import button.

    disableLoadContent = =>
      modal.adjustPrimaryButton(null)

    enableLoadContent = (type, contentId) =>
      modal.adjustPrimaryButton("Import", ->
        url =
          if type == "campaigns" || type == "templates"
            Routes.campaign_content_api_v2_content_path(contentId, { normalize_content_images: "1" })
          else if type == "autoresponders"
            Routes.autoresponder_content_api_v2_content_path(contentId, { normalize_content_images: "1" })

        if url
          $.getJSON url, (r) =>
            if r.success
              content = r.data
              doLoadContent(content)
      )

    doLoadContent = (content) =>
      $(".content-subject input", $contentEditorSection).val(content.subject).trigger("change")
      $(".content-format select", $contentEditorSection).val(content.format).trigger("change")
      ContentEditor.setup($(".editor_subsection_html .editor-container", $contentEditorSection)).setContent(content.html) if content.format != "text"
      ContentEditor.setup($(".editor_subsection_text .editor-container", $contentEditorSection)).setContent(content.text) if content.format != "html"
      modal("hide")

    # Set up "Mailing List" selection.

    $mailingListSelect.on "change", =>

      modal.adjustPrimaryButton(null)

      mailingListId = $mailingListSelect.val()

      $sourceLine.hide()
      $contentLine.hide()

      return if mailingListId == ""

      # We selected a mailing list. Set up its "Source" selection.

      $.getJSON Routes.content_sources_api_v2_mailing_list_path(mailingListId), (r) =>

        sources = {}

        # Build the "Source" input field.

        $sourceSelect.html("")
        $sourceSelect.append($("<option></option>").attr("value", "").text("Select a source ..."))
        _.each [ "campaigns", "templates", "autoresponders" ], (type) =>
          $optgroup = $("<optgroup></optgroup>").attr("label", type)
          _.each r.data[type], (obj) =>
            id = "#{ type }_#{ obj.id }"
            if id != thisObjectId
              sources[id] = obj
              sources[id].type = type
              $option = $("<option></option>").attr("value", id).text(obj.name)
              $optgroup.append($option)
          $sourceSelect.append($optgroup)
        $sourceLine.show()

        # Respond to a source selection.

        $sourceSelect.off("change.content-importer").on "change.content-importer", =>

          source = sources[$sourceSelect.val()]

          $contentLine.hide()
          $contentSelect.off("change.content-importer")

          modal.adjustPrimaryButton(null)

          if !source || !source.contents || source.contents.length < 1
            # No contents, can't load content.
          else if source.contents.length == 1
            enableLoadContent(source.type, source.contents[0].id)
          else
            modal.adjustPrimaryButton(null)
            $contentSelect.html("")
            $contentSelect.append($("<option></option>").attr("value", "").text("Select a content ..."))
            _.each source.contents, (obj) =>
              $option = $("<option></option>").attr("value", obj.id).text(obj.name)
              $contentSelect.append($option)
            $contentLine.show()

            $contentSelect.off("change.content-importer").on "change.content-importer", =>
              contentId = $contentSelect.val()
              disableLoadContent()

              if contentId != ""
                enableLoadContent(source.type, contentId)

          true

      true
